// This module contains pricing calculation helper functions

(function() {
  'use strict';

  window.PB_formatCurrency = function(amount) {
    if (typeof amount !== 'number' || isNaN(amount)) {
      return '$0.00';
    }
    return '$' + amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  window.PB_getPromo2Pricing = function(params) {
    const { pmapPrice, mapPrice, variantPrice, marginPercent, bundleDiscountPercent, isLoggedIn } = params;

    // For Promo 2: Always use PMAP as the display price (fall back to MAP, then variant price)
    const displayPrice = pmapPrice || mapPrice || variantPrice;

    // Promo 2 items get NO additional bundle discount - they're already at highest promotional price
    const productDiscount = 0;

    // Your Price = PMAP * (1 - margin/100)
    let yourPrice = displayPrice;
    if (isLoggedIn && marginPercent > 0) {
      yourPrice = displayPrice * (1 - marginPercent / 100);
    }

    // Determine eligibility message
    let eligibilityMessage = '';
    if (bundleDiscountPercent === 0.12) {
      eligibilityMessage = 'Already at highest promotional price';
    } else if (bundleDiscountPercent > 0 && bundleDiscountPercent < 0.12) {
      eligibilityMessage = 'Special Promo items only eligible at 6+ items';
    }

    return {
      displayPrice: parseFloat(displayPrice.toFixed(2)),
      productDiscount: 0,
      yourPrice: parseFloat(yourPrice.toFixed(2)),
      priceLabel: pmapPrice ? 'PMAP' : (mapPrice ? 'MAP' : 'Price'),
      eligibilityMessage,
      isAtHighestDiscount: bundleDiscountPercent === 0.12
    };
  };

  window.PB_getPromoPricing = function(params) {
    const { pmapPrice, mapPrice, variantPrice, marginPercent, bundleDiscountPercent, isLoggedIn } = params;

    // At 6+ items (12% tier): use MAP and apply bundle discount
    // At < 6 items: use PMAP, no bundle discount
    const isAtSixPlusItems = bundleDiscountPercent === 0.12;

    let displayPrice;
    let productDiscount = 0;
    let priceLabel;
    let originalPmapPrice = pmapPrice; // Store original PMAP for strikethrough display

    if (isAtSixPlusItems) {
      // 6+ items: Display MAP, apply 12% discount off MAP
      displayPrice = mapPrice || pmapPrice || variantPrice;
      productDiscount = displayPrice * 0.12;
      priceLabel = 'MAP';
    } else {
      // < 6 items: Display PMAP, no discount
      displayPrice = pmapPrice || mapPrice || variantPrice;
      productDiscount = 0;
      priceLabel = pmapPrice ? 'PMAP' : (mapPrice ? 'MAP' : 'Price');
    }

    // Your Price = (displayPrice - productDiscount) * (1 - margin/100)
    const priceAfterDiscount = displayPrice - productDiscount;
    let yourPrice = priceAfterDiscount;
    if (isLoggedIn && marginPercent > 0) {
      yourPrice = priceAfterDiscount * (1 - marginPercent / 100);
    }

    // Determine eligibility message
    let eligibilityMessage = '';
    if (!isAtSixPlusItems && bundleDiscountPercent > 0) {
      eligibilityMessage = 'Promo items only eligible for 12% discount (6+ items)';
    }

    // Show strikethrough PMAP when at 6+ items and PMAP exists and is different from MAP
    const showStrikethroughPmap = isAtSixPlusItems && originalPmapPrice && mapPrice && originalPmapPrice !== mapPrice;

    return {
      displayPrice: parseFloat(displayPrice.toFixed(2)),
      productDiscount: parseFloat(productDiscount.toFixed(2)),
      priceAfterDiscount: parseFloat(priceAfterDiscount.toFixed(2)),
      yourPrice: parseFloat(yourPrice.toFixed(2)),
      priceLabel,
      eligibilityMessage,
      isAtSixPlusItems,
      showStrikethroughPmap,
      originalPmapPrice: originalPmapPrice ? parseFloat(originalPmapPrice.toFixed(2)) : null
    };
  };

  window.PB_getProductPricing = function(productId) {
    const defaultPricing = {
      map: null,
      pmap: null,
      yourPrice: null,
      marginPercent: 0
    };

    if (!window.PB_MAP_PRICES || !window.PB_MAP_PRICES[productId]) {
      return defaultPricing;
    }

    const priceData = window.PB_MAP_PRICES[productId];
    return {
      map: priceData.map ? parseFloat(priceData.map) : null,
      pmap: priceData.pmap ? parseFloat(priceData.pmap) : null,
      yourPrice: priceData.yourPrice ? parseFloat(priceData.yourPrice) : null,
      marginPercent: priceData.marginPercent ? parseFloat(priceData.marginPercent) : 0
    };
  };

  console.log('Package Builder Pricing loaded');
})();
